import { z } from "zod";

import { Logger } from "@abacus/common";

export const emailSchema = z.string().email().describe("User email address");

export const createAbacusProfilesJobConfigSchema = z
  .object({
    logger: (z.unknown() as z.ZodType<Logger>).optional(),
  })
  .optional();

export const createAbacusProfilesJobDataSchema = z.object({
  emails: z.array(emailSchema),
});
